// extracted by mini-css-extract-plugin
export default {"root":"FormGridTemplate_root__H0RT9","placeHolderShimmer":"FormGridTemplate_placeHolderShimmer__KGxhS"};